import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ztn-drawer-item" }
const _hoisted_2 = { class: "ztn-drawer-item__label ztn-page-h400-strong" }
const _hoisted_3 = { class: "ztn-drawer-item__value ztn-page-t300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.label)), 1)
        ], true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.value), 1)
        ], true)
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
  ], 64))
}